import { render, staticRenderFns } from "./RegionalRumble.vue?vue&type=template&id=944a89ce&"
import script from "./RegionalRumble.vue?vue&type=script&lang=js&"
export * from "./RegionalRumble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports